import React from 'react';
import site from '../data/site.json';

const ORGANIZATION_ID = `${site.url}/#verein`;
const AIRPORT_ID = `${site.url}/#flugplatz`;
const WEBSITE_ID = `${site.url}/#website`;

const postalAddress = {
  '@type': 'PostalAddress',
  streetAddress: site.address.street,
  postalCode: site.address.postalCode,
  addressLocality: site.address.city,
  addressRegion: site.address.region,
  addressCountry: site.address.country,
};

const geo = {
  '@type': 'GeoCoordinates',
  latitude: site.airfield.latitude,
  longitude: site.airfield.longitude,
};

// Verein, Flugplatz, Website und Rundflug-Angebote (schema.org) – Preise kommen aus src/data/site.json
export const homeStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'SportsClub',
      '@id': ORGANIZATION_ID,
      name: site.name,
      alternateName: site.shortName,
      description: site.description,
      url: `${site.url}/`,
      logo: `${site.url}/images/logo.png`,
      image: [`${site.url}/images/Flugsportverein_Bilder_1.jpg`, `${site.url}/images/Flugsportverein_Bilder_11.jpg`],
      foundingDate: site.foundingDate,
      telephone: site.phone.e164,
      email: site.email,
      address: postalAddress,
      geo,
      sameAs: [site.social.instagram, site.social.facebook, site.social.facebookAlt],
      knowsAbout: ['Segelflug', 'Ultraleichtflug', 'Rundflüge', 'Gastflüge', 'Flugausbildung', 'Segelfluglizenz (GPL)', 'Sportpilotenlizenz (SPL)'],
      location: { '@id': AIRPORT_ID },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Rundflüge & Gastflüge',
        itemListElement: site.packages.map((pkg) => ({
          '@type': 'Offer',
          name: `${pkg.title} (${pkg.duration})`,
          description: pkg.description,
          price: pkg.price.toFixed(2),
          priceCurrency: 'EUR',
          validFrom: site.pricesValidFrom,
          availability: 'https://schema.org/InStock',
          url: `${site.url}/#rundflug`,
          image: `${site.url}${pkg.image}`,
          seller: { '@id': ORGANIZATION_ID },
          itemOffered: {
            '@type': 'Service',
            name: `${pkg.title} (${pkg.duration})`,
            serviceType: 'Rundflug',
            areaServed: 'Thüringen',
            provider: { '@id': ORGANIZATION_ID },
          },
        })),
      },
    },
    {
      '@type': 'Airport',
      '@id': AIRPORT_ID,
      name: site.airfield.name,
      icaoCode: site.airfield.icao,
      description: 'Sonderlandeplatz ca. 3 km nördlich von Bad Langensalza für Segel- und Ultraleichtflugzeuge.',
      url: `${site.url}/flugplatzinfo`,
      address: postalAddress,
      geo,
    },
    {
      '@type': 'WebSite',
      '@id': WEBSITE_ID,
      url: `${site.url}/`,
      name: site.shortName,
      inLanguage: 'de-DE',
      publisher: { '@id': ORGANIZATION_ID },
    },
  ],
};

export const breadcrumbStructuredData = (name: string, path: string) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Startseite', item: `${site.url}/` },
    { '@type': 'ListItem', position: 2, name, item: `${site.url}${path}` },
  ],
});

// JSON-LD als <script>-Tag; landet über das Pre-Rendering im statischen HTML
const StructuredData: React.FC<{ data: object }> = ({ data }) => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
);

export default StructuredData;
